import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewChild,
    ViewChildren,
    QueryList,
    //forwardRef
    ViewContainerRef,
    Renderer2,
    ComponentFactoryResolver,
    Type as AngularCoreType
} from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormBuilder, FormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms'; // Used for Reactive Forms

import { DynamicComponentHostDirective } from '../../../directives/dynamic-content-host.directive';
import { ControlType, ValidationInfo, ValidationMessageInfo, FormFieldBaseComponent } from '../form-field-base/form-field-base.component';
import { FormField } from '../../../models/form-builder/form-field.model';
import { FormInstanceElement } from '../../../models/form-builder/form-instance-element.model';

@Component({
    selector: 'app-dev-only-form-field',
    templateUrl: './dev-only-form-field.component.html',
    styleUrls: ['./dev-only-form-field.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: DevOnlyFormFieldComponent,
            multi: true
        }
    ],
    standalone: false
})
// Note:  this component is only used during development, used to 
//        test things before trying them with the actual form fields.
export class DevOnlyFormFieldComponent extends FormFieldBaseComponent implements OnInit {
    // Properties.
    // Note:  inputs have been moved into my base class.

    @Output() onInit = new EventEmitter();

    private readonly formFieldNames: string[] =
        ['name',
            'fieldGroup',
            'required',
            'displayName',
            'blankValue',
            'helpText',
            'placeholderText',
            'toolTip',
            'defaultValue',
            'maxLength',
            'displayFormat', // NOTE:  temporarily using display format to display optional validations.
            'constraint'
            //'regex'
        ];

    private readonly validationOptions: ValidationInfo[] =
        [
            {
                DISPLAY_NAME: 'None',
                IS_CUSTOM_REGULAR_EXPRESSION: false,
                REGULAR_EXPRESSION: null,
                ERROR_MESSAGE: null
            },
            {
                DISPLAY_NAME: 'Email',
                IS_CUSTOM_REGULAR_EXPRESSION: false,
                REGULAR_EXPRESSION: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/,
                ERROR_MESSAGE: 'must contain a valid email address'
            },
            {
                DISPLAY_NAME: 'Phone Number',
                IS_CUSTOM_REGULAR_EXPRESSION: false,
                REGULAR_EXPRESSION: /^[0-9][0-9][0-9]-[0-9][0-9][0-9]-[0-9][0-9][0-9][0-9]$/,
                ERROR_MESSAGE: 'must contain a phone number in NNN-NNN-NNNN format'
            }
        ];

    private iNumTemplateRows: number = 250;
    private iNumTemplateColumns: number = 3;

    //@ViewChild(DynamicComponentHostDirective, { read: DynamicComponentHostDirective }) dynamicComponentHost: DynamicComponentHostDirective;
    //@ViewChildren(DynamicComponentHostDirective, { read: DynamicComponentHostDirective }) dynamicComponentHosts: QueryList<DynamicComponentHostDirective>;
    @ViewChildren(DynamicComponentHostDirective, { read: ViewContainerRef }) dynamicComponentHosts: QueryList<DynamicComponentHostDirective>;

    private abSpanSelectedFlags: boolean[] = null;
    private iSelectedRow: number = -1;
    private iSelectedCol: number = -1;

    // Define properties used with Reactive Forms.
    //shortTextFormControl: FormControl = null;
    // End properties used with Reactive Forms.

    // Constructor.
    constructor(private resolver: ComponentFactoryResolver,
        private renderer: Renderer2) {
        super();

        this.abSpanSelectedFlags = Array(this.iNumTemplateColumns * this.iNumTemplateColumns);

        return;
    }

    // Implement abstract methods.
    public getProperties(): any {
        // Note:  temporarily passing validation options as display formats.
        let validationNames: string[] = [];
        for (let iValidation: number = 0; iValidation < this.validationOptions.length; iValidation++) {
            let validationInfo: ValidationInfo = this.validationOptions[iValidation];

            validationNames.push(validationInfo.DISPLAY_NAME);
        }

        let hshOnInitProperties = {
            component: this,
            formField: this.FormField,
            properties: this.formFieldNames,
            //displayFormatValues: validationNames, // Need to disable this.
            constraintNames: validationNames
        };

        return (hshOnInitProperties);
    }

    // Life cycle methods.
    ngOnInit(): void {
        // Set a default constraint value.
        if (this.FormField) {
            if (!this.FormField.constraintName) {
                this.FormField.constraintName = "None";
            }
        }

        // Note:  temporarily passing validation options as display formats.
        /*
        let validationNames: string[] = [];
        for (let iValidation: number = 0; iValidation < this.validationOptions.length; iValidation++) {
            let validationInfo: ValidationInfo = this.validationOptions[iValidation];

            validationNames.push(validationInfo.DISPLAY_NAME);
        }

        // Assemble my properties hash.
        let hshOnInitProperties = {
            component: this,
            formField: this.formField,
            properties: this.formFieldNames,
            //displayFormatValues: validationNames, // Need to disable this.
            constraintNames: validationNames
        };
        */
        let hshOnInitProperties = this.getProperties();

        // Note:  enbable this emit() when using this component class.
        //this.onInit.emit(hshOnInitProperties);

        return;
    }

    ngAfterViewInit(): void {
        // Note:  @ViewChild() and @ViewChildren() value can be seen
        //        when this method is called but generally not before.

        return;
    }

    // Accessor methods used in my HTML.
    public get NumTemplateRows(): number {
        return (this.iNumTemplateRows);
    }

    public get TemplateRowIndexes(): any[] {
        let result: any[] = Array(this.iNumTemplateRows);

        return (result);
    }

    public get TemplateColumnIndexes(): any[] {
        let result: any[] = Array(this.iNumTemplateColumns);

        return (result);
    }

    public SelectedFlag(iRow: number, iCol: number): boolean {
        let bSelectedFlag: boolean = false;

        if ((iRow >= 0) && (iCol >= 0)) {
            if ((iRow < this.iNumTemplateRows) && (iCol < this.iNumTemplateColumns)) {
                let iFlagIndex: number = (iRow * this.iNumTemplateColumns) + iCol;

                bSelectedFlag = this.abSpanSelectedFlags[iFlagIndex];
            }
        }

        return (bSelectedFlag);
    }

    // Override base class methods.
    protected formInstanceElementReceived(): void {
        if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
            if (this.ControlType === ControlType.REACTIVE_FORMS) {
                // If I have no value assigned but
                // have a default value, apply it now.
                this.setDefaultTextValue();

                // Use a base class method to
                // set up a decimal form group.
                this.setupTextFormControl();
            } // if (this.controlType === ControlType.REACTIVE_FORMS)
        } // if ((this.Mode === 'preview') || (this.Mode === 'instance'))

        return;
    }

    //TEAMS-561: KLW - Implement the first instance of writeValueTrigger which will eventually replace formInstanceElementReceived
    protected writeValueTriggered(): void {
        if ((this.Mode === 'preview') || (this.Mode === 'instance')) {
            if (this.ControlType === ControlType.REACTIVE_FORMS) {
                // If I have no value assigned but
                // have a default value, apply it now.
                this.setDefaultTextValue();

                // Use a base class method to
                // set up a decimal form group.
                this.setupTextFormControl();
            } // if (this.controlType === ControlType.REACTIVE_FORMS)
        } // if ((this.Mode === 'preview') || (this.Mode === 'instance'))

        return;
    }


    // Override the getDisplayValue() base class method.
    // Define a method that allows a component to return its display value.
    public pseudoStatic_getDisplayValue(formFieldParam: FormField, formInstanceElementParam: FormInstanceElement): string {
        let strValue: string = `${formFieldParam.name} value`;

        return (strValue);
    }

    // Override a method used to get my class.
    public getFormFieldClass(): AngularCoreType<any> {
        return (DevOnlyFormFieldComponent);
    }

    // Event handler methods.
    public spanClicked(iRow: number, iCol: number): void {
        // If a cell is currently selected, remove that selection.
        if ((this.iSelectedRow >= 0) && (this.iSelectedCol >= 0)) {
            this.clearTemplate(this.iSelectedRow, this.iSelectedCol);

            let iFlagIndex: number = (this.iSelectedRow * this.iNumTemplateColumns) + this.iSelectedCol;

            this.abSpanSelectedFlags[iFlagIndex] = false;
        }

        // Create a control in the template that corresponds with the clicked span.
        this.createFieldControlInRowCell(iRow, iCol);

        // Set the clicked span's selected flag.
        this.iSelectedRow = iRow;
        this.iSelectedCol = iCol;

        let iFlagIndex: number = (this.iSelectedRow * this.iNumTemplateColumns) + this.iSelectedCol;
        this.abSpanSelectedFlags[iFlagIndex] = true;

        return;
    }

    // Override other protected base class methods.
    protected buildValidatorFunctionsAndMessages(
        arrValidatorsParam: ValidatorFn[],
        arrValidationMessagesParam: ValidationMessageInfo[]): void {
        // First call super.
        super.buildValidatorFunctionsAndMessages(arrValidatorsParam, arrValidationMessagesParam);

        // If I have a selected validation format, apply it here.
        // Note:  temporarily using display format as an optional validation format.
        //if (this.FormField.displayFormat && (this.FormField.displayFormat.trim() !== '')) {
        if (this.FormField.constraintName && (this.FormField.constraintName.trim() !== '')) {
            //let arrValidationOption: ValidationInfo[] = this.validationOptions.filter(vi => vi.DISPLAY_NAME === this.FormField.displayFormat);
            let arrValidationOption: ValidationInfo[] = this.validationOptions.filter(vi => vi.DISPLAY_NAME === this.FormField.constraintName);

            if (arrValidationOption && (arrValidationOption.length === 1)) {
                let validationOption: ValidationInfo = arrValidationOption[0];

                // Don't apply both a named validation and a regular expression.
                // A this.FormField.regex expression would have been applied in
                // the above call to the base class's method.
                if (!this.FormField.regex) {
                    arrValidatorsParam.push(Validators.pattern(validationOption.REGULAR_EXPRESSION));

                    arrValidationMessagesParam.push({ type: 'pattern', message: `${this.DisplayName} ${validationOption.ERROR_MESSAGE}` });
                }
            }
        }

        // Done.
        return;
    }

    // Implement private helper methods.
    private createFieldControlInRowCell(iRow: number, iCol: number): void {
        // Get the template that corresponds to the clicked <span/>.
        let iTemplateIndex: number = (iRow * this.iNumTemplateColumns) + iCol;

        if (this.dynamicComponentHosts) {
            if (this.dynamicComponentHosts.length > iTemplateIndex) {
                let templateViewContainerRefs: ViewContainerRef[] =
                    <ViewContainerRef[]><unknown>this.dynamicComponentHosts.toArray();

                let viewContainerRef: ViewContainerRef = templateViewContainerRefs[iTemplateIndex];

                // creating the mat-checkbox tag body content
                let content = this.renderer.createText(' mat-checkbox (dynamic)');
                // clear any previously appended element or component
                viewContainerRef.clear();
                // resolve the MatCheckbox component and get the factory class to create the component dynamically
                let factory = this.resolver.resolveComponentFactory(MatCheckbox);
                // create the component and append to the placeholder in the template
                let ref = viewContainerRef.createComponent(factory);
                // set the mat-checkbox body content
                (ref.location.nativeElement as HTMLElement).appendChild(content);
            }
        }

        // Done.
        return;
    }

    private clearTemplate(iRow: number, iCol: number): void {
        let iTemplateIndex: number = (iRow * this.iNumTemplateColumns) + iCol;

        if (this.dynamicComponentHosts) {
            if (this.dynamicComponentHosts.length > iTemplateIndex) {
                let templateViewContainerRefs: ViewContainerRef[] =
                    <ViewContainerRef[]><unknown>this.dynamicComponentHosts.toArray();

                let viewContainerRef: ViewContainerRef = templateViewContainerRefs[iTemplateIndex];

                // clear any previously appended element or component
                viewContainerRef.clear();
            }
        }

        return;
    }
}
